import * as React from 'react';
import { decodeHTMLEntities } from "../helpers/utils.ts";
import type { PageSectionData } from "../rest.interface";
import RenderContent from "./renderContent";
import tailwindCompiler from "./tailwindCompiler";

export default async function renderContentCss(content: PageSectionData[], renderContentToString: Function) {
	const previewHtml = (<>
		<html className="fonts-loaded">
		<head>
			<title>Preview</title>
		</head>
		<body>
		<div className="cms-sections">
			<RenderContent content={content}/>
		</div>
		</body>
		</html>
	</>);

	let html = await renderContentToString(previewHtml);
	html = decodeHTMLEntities(html);
	return await tailwindCompiler(html);
}

